import { useEffect, useRef } from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';
import { scrollReveal, prefersReducedMotion } from '@/hooks/useGsap';

const faqs = [
  {
    question: "Apa itu AI Automation?",
    answer: "AI Automation adalah proses mengintegrasikan kecerdasan buatan (LLM seperti Claude/ChatGPT) ke dalam workflow pekerjaan berulang menggunakan platform seperti n8n atau Make.com untuk menghemat waktu dan meningkatkan efisiensi."
  },
  {
    question: "Apa bedanya Make.com dengan n8n?",
    answer: "Make.com adalah platform berbasis cloud dengan visual UI yang sangat ramah pengguna, cocok untuk pemula dan integrasi cepat. n8n lebih fleksibel, developer-friendly, dan bisa di-host sendiri (self-hosted) untuk privasi data maksimal."
  },
  {
    question: "Bagaimana cara memulai kolaborasi?",
    answer: "Kamu bisa langsung mengisi form di bagian Contact atau klik tombol Telegram untuk diskusi cepat. Kita akan mengidentifikasi bottleneck di workflow kamu dan merancang otomatisasi yang tepat."
  },
  {
    question: "Apakah saya harus bisa coding untuk memakai otomatisasi?",
    answer: "Tidak perlu. Sebagian besar otomatisasi dirancang menggunakan no-code atau low-code platform. Kami juga akan memberikan panduan praktis agar tim kamu bisa mengoperasikannya dengan mudah."
  }
];

const Faq = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (sectionRef.current) {
      scrollReveal(sectionRef.current);
    }
  }, []);

  return (
    <section
      id="faq"
      ref={sectionRef}
      className="section-padding section-atmosphere bg-background border-t border-border"
      style={{ opacity: prefersReducedMotion() ? 1 : 0 }}
    >
      <div className="container-site max-w-2xl mx-auto">
        <div className="section-title text-center mb-10">
          <span className="chip mb-4">FAQ</span>
          <h2 className="font-display uppercase font-light text-3xl sm:text-4xl tracking-[0.03em] text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xs uppercase tracking-wide leading-relaxed text-muted-foreground">
            Jawaban atas pertanyaan seputar AI automation dan workflow optimization.
          </p>
        </div>

        <div className="motion-panel bg-card p-6 sm:p-8 border border-border rounded-none shadow-sm">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`faq-${index}`} className="border-b border-border/40 last:border-b-0">
                <AccordionTrigger className="font-sans font-bold text-xs uppercase tracking-wider text-left text-foreground py-4 hover:no-underline hover:text-foreground">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-xs leading-relaxed text-muted-foreground pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default Faq;
